import React from 'react'
import PropTypes from 'prop-types'

const ShowHide = ({ show, children }) => (
  <div>
    {show ? children : null}
  </div>
)

ShowHide.propTypes = {
  show: PropTypes.bool,
}
ShowHide.defaultProps = {
  show: false,
}

export default ShowHide



// WEBPACK FOOTER //
// ./src/components/ShowHide/index.js